import ShieldTickIcon from "@redotech/redo-icons/shield-tick.svg";
import { Step as ModelStep } from "@redotech/redo-model/return-flow";
import { submitWarrantyRegistrationFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isSubmitWarrantyRegistrationStepValid,
  SubmitWarrantyRegistrationState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SUBMIT_WARRANTY_REGISTRATION = (
  Details: React.ComponentType<
    StepTypeDetailsProps<SubmitWarrantyRegistrationState>
  >,
): StepType<
  SubmitWarrantyRegistrationState,
  ModelStep.SubmitWarrantyRegistration
> => ({
  Details: (props: StepTypeDetailsProps<SubmitWarrantyRegistrationState>) =>
    React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  title: "Submit Warranty Registration",
  valid(state) {
    return isSubmitWarrantyRegistrationStepValid(state).valid;
  },
  Icon: ShieldTickIcon,
  description(state) {
    return "Submit warranty registration";
  },
  downstream() {
    return [];
  },
  maxDownstream() {
    return 0;
  },
  empty: {},
  layout() {
    return BlockLayout.FULL;
  },
  stepDeleted(state) {
    return state;
  },
  toModel(state) {
    return {
      customTitle: state.customTitle,
      type: ModelStep.SUBMIT_WARRANTY_REGISTRATION,
    };
  },
  fromModel(model) {
    return submitWarrantyRegistrationFromModel(model);
  },
});

export { type SubmitWarrantyRegistrationState } from "@redotech/redo-model/return-flow-step-valid";
